import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import firebase from 'firebase'
import SECRET from './secret.json'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTwitter,
	faInstagram,
	faTumblr
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

firebase.initializeApp(SECRET)

Vue.config.productionTip = false
Vue.prototype.$axios = Axios

library.add(faTwitter, faInstagram, faTumblr)

Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
